module.exports = __webpack_public_path__ + "img/auto_billing_image_page_x2.72981466.png";